<template>
  <el-timeline v-if="datalist?.length > 0">
    <el-timeline-item v-for="(item, index) in datalist" :key="index">
      <p class="text-sm text-info">
        {{ item.Operator }} 于 {{ item.CreateTime }}
      </p>
      <p class="text-space">{{ item.Remark }}</p>
      <p v-if="item.Files.length > 0">
        <el-link
          type="primary"
          v-for="file in item.Files"
          :key="file.id"
          :href="file.url"
          target="_blank"
          >{{ file.name }}</el-link
        >
      </p>
    </el-timeline-item>
  </el-timeline>
  <el-empty v-else />
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      datalist: [],
    };
  },
  props: {
    id: { type: String },
    type: { type: String },
  },
  created() {
    this.loadData();
  },
  methods: {
    // 信息列表
    loadData() {
      this.loading = true;
      this.$apis.system.record
        .list({
          id: this.id,
          type: this.type,
        })
        .then((res) => {
          this.datalist = res;
        })
        .catch((e) => {
          this.$message.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-timeline {
  padding: 20px;
  &-item:last-child {
    padding: 0;
  }
}
</style>
